import { render } from "./TextTruncation.vue?vue&type=template&id=2a457eac"
import script from "./TextTruncation.vue?vue&type=script&lang=js"
export * from "./TextTruncation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__